import { format, parseISO } from "date-fns";

/**
 *
 * @param {*} dateTimeString
 * @returns { date: '27NOV', time: '21:05' }
 */
export const parseDateTime = (dateTimeString) => {
  if (dateTimeString && !dateTimeString.includes("T")) {
    return { date: "N/A", time: "N/A" };
  }

  const date = parseISO(dateTimeString);

  if (isNaN(date)) {
    return { date: "N/A", time: "N/A" };
  }

  const formattedDate = format(date, "ddMMM").toUpperCase();
  const formattedTime = format(date, "HH:mm");

  return { date: formattedDate, time: formattedTime };
};
